import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from '../../../reducers/auth';
import { useSelector } from "react-redux";
import Image from "react-bootstrap/Image";
import { resolveImageUrl, resolveSwatchUrl } from '../../../utils/imageUrl';

const NonCatalogProduct = (props) => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const navigate = useNavigate();
  const loginStatus = useSelector(isLoggedIn);
  const [imgSrc, setImgSrc] = useState(null);
  const [currentColor, setCurrentColor] = useState(null);

  const imageOver = (item) => {
    setImgSrc(item.modelImage);
    setCurrentColor(item);
  }
  var showColors = true;
  if (props.showColors && props.showColors === "hide") {
    showColors = false;
  }
  const colors = Array.isArray(props.product.colors) ? props.product.colors : [];
  let featuredColor = null;
  if (props.product.featuredColor != null) {
    for (var i = 0; i < colors.length; i++) {
      if (colors[i].colorId === props.product.featuredColor) {
        featuredColor = colors[i];
      }
    }
  }
  if (featuredColor === null && colors.length > 0)
    featuredColor = colors[0];

  console.log("PRODUCT", props.product);

  return (
    <div class="product" onClick={() => { navigate(`../admin/allproduct/details/` + props.product.id, { state: { productId: props.product.id, colorId: currentColor?.colorId }, replace: true }); }}>



      <div class="modelImage">
        <Image className="modelImageImg" src={resolveImageUrl(imgSrc || featuredColor?.modelImage)} fluid alt="Model Image"></Image>
        </div>
      <div class="title">{props.product.title}</div>
      <div>Source: {props.product.source}</div>
      {loginStatus ? (
        <div class="price">${props.product.minPrice} - ${props.product.maxPrice}</div>
      ) : null}
      <div class="colors">{props.product.colorCount} Colors available</div>
      {showColors &&
        <div class="colors">
          {colors.map(color => (
            <div className="color-swatch">

              {color.hexColor && color.hexColor != "" && !(color.colorImage && color.colorImage != "") && (
                <div style={{ backgroundColor: color.hexColor, width: 20, height: 20 }}></div>
              )}
              {color.colorImage && color.colorImage != "" && (
                <img src={color.colorImage.startsWith("Images") || /^https?:\/\//i.test(color.colorImage) ? resolveSwatchUrl(color.colorImage) : `${apiUrl}/images/csi/${color.colorImage}`} alt={`${color.colorName}`} height={30}
                  onMouseOver={(event) => imageOver(color)}
                />

              )}


            </div>
          ))}
        </div>
      }
    </div>
  );
};

export default NonCatalogProduct;